<template>
  <div class="card">
    <div class="is-paddingless">
      <header class="bandeau-modal card-header">
      </header>
      <div class="center pdt-20px pdh-5">
        <h1 class="title is-size-3">
          {{ $t('catalogue.popUpCheckFacesImpact.title') }}
        </h1>
      </div>
      <div class="card-content">
        <error-msg-component
          :messages="messagesError"
          :error="error"
          title="general.problemOccurred"
          @close="error = $event"/>
        <section class="">
          <div v-if="showFacesImpacteesVente">
            <h5 class="title is-size-5 mgb-20px">
              {{ $t('catalogue.popUpCheckFacesImpact.descriptionListeVente') }}
            </h5>
            <liste-faces-reseau-impactees
              :faces-impactees="facesImpacteesVentes"
            />
          </div>
          <div v-if="showFacesImpacteesLogistique">
            <h5 class="title is-size-5 mgb-20px">
              {{ $t('catalogue.popUpCheckFacesImpact.descriptionListeLogistique') }}
            </h5>
            <liste-faces-reseau-impactees
              :faces-impactees="facesImpacteesLogistiques"
            />
          </div>
          <div>
            <h5 class="title is-size-5">
              {{ $t('catalogue.popUpCheckFacesImpact.vousSouhaitez') }}
            </h5>
            <div class="mgl-10px columns is-align-items-center is-marginless">
              <p class="column is-5">
                {{ $t('catalogue.popUpCheckFacesImpact.action.telechargerFichierExcelImpacts') }}
              </p>
              <div class="column is-narrow">
                <async-check-button
                  :key="currentTab"
                  :label="$t('general.button.export')"
                  :permissions="constantes.CATALOGUE.exporter"
                  :query="exportExcelImpacts"/>
              </div>
            </div>
            <div
              v-if="showFacesImpacteesVente"
              class="mgl-10px columns is-align-items-center is-marginless">
              <p class="column is-5">
                {{ $t('catalogue.popUpCheckFacesImpact.action.prevenirParEmailCommerciaux') }}
              </p>
              <div class="column is-narrow">
                <async-check-button
                  :key="currentTab"
                  :label="$t('general.button.prevenir')"
                  :permissions="constantes.CATALOGUE.lecture"
                  :query="prevenirParEmailCommerciaux"/>
              </div>
            </div>
          </div>
        </section>
        <footer class="mgt-10px">
          <div class="has-text-right">
            <button
              type="button"
              class="button btn-modal-annuler is-cancel has-text-centered button-modal"
              @click="$parent.close()">
              {{ $t('general.button.cancel') }}
            </button>
            <button
              type="button"
              class="button is-primary has-text-centered button-modal"
              @click="handleNext">
              {{ showNextTabAction ? $t('general.button.next') : $t('general.button.terminer') }}
            </button>
          </div>
        </footer>
      </div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import { reseauFaceImpactEmailAsync } from '@/api/mail';
import exportExcel from '@/api/exportExcel/index';
import ErrorMsgComponent from '@/components/general/errorMsgComponent';
import AsyncCheckButton from '@/components/general/button/asyncCheckButton';
import ListeFacesReseauImpactees from '@/components/catalogue/produitReseau/listeFacesReseauImpactees';
import {
  FACE_TYPE_IMPACT_LOGISTIQUE,
  FACE_TYPE_IMPACT_VENTE,
  EXPORT_EXCEL_RESEAU_FACES_IMPACT,
} from '@/configuration/catalogue/produitConf';
import { CATALOGUE } from '@/configuration/permissionsBodacConf';
import messageErreur from '@/services/general/messageErreur';
import { formatProduitBeforeSave } from '@/services/catalogue/formatProduit';

const Societe = createNamespacedHelpers('societe');

export default {
  name: 'PopUpEditionPlanningReseauxTemposLC',
  props: {
    facesImpactees: {
      type: Array,
      required: true,
    },
    produit: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      error: false,
      messagesError: [],
      currentTab: FACE_TYPE_IMPACT_VENTE,
      constantes: {
        CATALOGUE,
      },
    };
  },
  components: {
    ErrorMsgComponent,
    AsyncCheckButton,
    ListeFacesReseauImpactees,
  },
  computed: {
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
    }),
    facesImpacteesVentes() {
      return this.facesImpactees
        .filter(face => face.faceImpactType === FACE_TYPE_IMPACT_VENTE);
    },
    facesImpacteesLogistiques() {
      return this.facesImpactees
        .filter(face => face.faceImpactType === FACE_TYPE_IMPACT_LOGISTIQUE);
    },
    showFacesImpacteesVente() {
      return this.facesImpacteesVentes.length > 0 && this.currentTab === FACE_TYPE_IMPACT_VENTE;
    },
    showFacesImpacteesLogistique() {
      return this.facesImpacteesLogistiques.length > 0
        && this.currentTab === FACE_TYPE_IMPACT_LOGISTIQUE;
    },
    tabs() {
      const res = [];
      if (this.facesImpacteesVentes.length > 0) {
        res.push(FACE_TYPE_IMPACT_VENTE);
      }
      if (this.facesImpacteesLogistiques.length > 0) {
        res.push(FACE_TYPE_IMPACT_LOGISTIQUE);
      }
      return res;
    },
    showNextTabAction() {
      const indexCurrentTab = this.tabs.indexOf(this.currentTab);
      return this.tabs.length > 1 && indexCurrentTab < this.tabs.length - 1;
    },
  },
  methods: {
    initializeTab() {
      this.currentTab = this.tabs[0];
    },
    async exportExcelImpacts() {
      const copyProduit = formatProduitBeforeSave(cloneDeep(this.produit));
      const payload = {
        reseauId: copyProduit.id,
        affectationsReseauFace: copyProduit.produitReseau.affectationsReseauFace,
      };
      try {
        const response = await exportExcel({
          typeDonnee: EXPORT_EXCEL_RESEAU_FACES_IMPACT,
          typeExport: this.currentTab.toLowerCase(),
          filtres: { query: payload },
        });
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(response.data);
        const disposition = response.request.getResponseHeader('Content-Disposition');
        link.download = decodeURI(disposition.match(/filename\*=UTF-8''(.*?)$/)[1]);
        link.click();
      } catch (e) {
        messageErreur(this.$i18n, this.$i18n.t('general.messages.error.excelError'));
        throw e;
      }
    },
    async prevenirParEmailCommerciaux() {
      const copyProduit = formatProduitBeforeSave(cloneDeep(this.produit));
      const payload = {
        reseauId: copyProduit.id,
        affectationsReseauFace: copyProduit.produitReseau.affectationsReseauFace,
      };
      try {
        await reseauFaceImpactEmailAsync({ societeId: this.societeActiveId }, payload);
      } catch (e) {
        messageErreur(this.$i18n, this.$i18n.t('general.messages.error.excelError'));
        throw e;
      }
    },
    handleNext() {
      if (this.showNextTabAction) {
        this.currentTab = this.tabs[this.tabs.indexOf(this.currentTab) + 1];
        return;
      }
      this.$parent.close();
      this.$emit('isFinished');
    },
  },
  mounted() {
    this.initializeTab();
  },
};

</script>
